module.exports = __webpack_public_path__ + "img/biodiversity_and_ecosystems.7f199a7.svg";